import DashboardLayout from '@/layouts/DashboardLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { UsersRouteName } from '@/types/router/name/users';
import { UsersRoutePath } from '@/types/router/path/users';

export default [
    {
        path: UsersRoutePath.Users,
        name: UsersRouteName.Users,
        component: () => import('@/pages/users/index.vue'),
        meta: {
            group: 'users',
            title: 'Users',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: UsersRoutePath.Geolocation,
        name: UsersRouteName.Geolocation,
        component: () => import('@/pages/users/geolocation/index.vue'),
        meta: {
            group: 'users-geolocation',
            title: 'Geolocation Users',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: UsersRoutePath.Analytic,
        name: UsersRouteName.Analytic,
        component: () => import('@/pages/users/analytic/index.vue'),
        meta: {
            group: 'users-analytic',
            title: 'Analytics Users',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
